import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReCaptcha } from 'react-recaptcha-v3';
import { Icon, Form, Input, Button, message } from 'antd';
import { hasErrors, setCookie } from '../../common/utils';
import { userLogin } from '../../common/fetch';
import { CAPTCHA_SITE_KEY } from '../../config/constants';
import { FormWrapper } from './style';

class Login extends Component {
	state = {
		num: parseInt((Math.random() * 100) % 11, 10) + 1
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const { history } = this.props;
		if (
			getFieldValue('email') === undefined ||
			getFieldValue('password') === undefined
		) {
			return;
		}
		const otp = getFieldValue('otp_code');
		const body = {
			email: getFieldValue('email'),
			password: getFieldValue('password'),
			captcha: this.recaptcha
		};
		if(otp !== undefined && otp !== ''){
			body.otp_code = otp;
		}
		try {
			const res = await userLogin(body);
			if (res && res.data) {
				setCookie('email', getFieldValue('email'));
				history.push('/verify-code');
				message.success(res.data.message);
			}
		} catch (error) {
			this.captcha.execute();
			message.warning('Error : ' + error.data.message);
		}
	};

	setRef = (el) => {
		this.captcha = el;
	};

	onVerifyCallback = (value) => {
		this.recaptcha = value;
	};

	onExpiredCallback = () => {
		this.recaptcha = '';
		this.captcha.execute();
	};

	render() {
		const {
			getFieldDecorator,
			getFieldsError,
			getFieldError,
			isFieldTouched
		} = this.props.form;

		const usernameError = isFieldTouched('email') && getFieldError('email');

		const passwordError =
			isFieldTouched('password') && getFieldError('password');
		return (
			<FormWrapper>
				<h3>Login</h3>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item
						validateStatus={usernameError ? 'error' : ''}
						help={usernameError || ''}
					>
						{getFieldDecorator('email', {
							rules: [
								{
									type: 'email',
									message: 'The input is not valid E-mail!'
								},
								{
									required: true,
									message: 'Please input your Email!'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="mail"
										style={{ color: '#42454D' }}
									/>
								}
								placeholder="Email"
							/>
						)}
					</Form.Item>
					<Form.Item
						validateStatus={passwordError ? 'error' : ''}
						help={passwordError || ''}
					>
						{getFieldDecorator('password', {
							rules: [
								{
									required: true,
									message: 'Please input your Password!'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="lock"
										style={{ color: '#42454D' }}
									/>
								}
								type="password"
								placeholder="Password"
							/>
						)}
					</Form.Item>
					<Form.Item>
						{getFieldDecorator('otp_code')(
							<Input
								prefix={
									<Icon
										type="lock"
										style={{ color: '#42454D' }}
									/>
								}
								placeholder="Two-factor authentication (if enabled)"
							/>
						)}
					</Form.Item>
					<div className="btn-area">
						<ReCaptcha
							sitekey={CAPTCHA_SITE_KEY}
							verifyCallback={this.onVerifyCallback}
							expiredCallback={this.onExpiredCallback}
							ref={this.setRef}
						/>
						<Button
							block
							type="primary"
							htmlType="submit"
							disabled={hasErrors(getFieldsError())}
						>
							Login
						</Button>
						<div className="link">
							Don't have an account?&nbsp;
							<Link to="/signup">Create one here.</Link>
						</div>
						<div className="forgot-password">
							<Link to="/recover">Can't login?</Link>
						</div>
					</div>
				</Form>
			</FormWrapper>
		);
	}
}

const WrappedHorizontalLoginForm = Form.create({ name: 'login form' })(Login);

export default WrappedHorizontalLoginForm;
